/**
 * Created by pandemio on 3/26/19.
 */

import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import FormCouponManager from '../forms/form-coupon-manager';

/**
 * Modal to handle the coupons
 */
class ModalCouponManager extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible,
            coupon: props.coupon
        };
        this.toggle = this.toggle.bind(this);
    }

    componentWillReceiveProps(props)
    {
        this.setState({
            visible: props.visible,
            coupon: props.coupon
        });
    }
    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            visible: !this.state.visible
        },()=>{
            this.props.updateParent(!this.state.visible);
        });
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.visible} toggle={this.toggle}>
                    <ModalHeader>
                        <Translate id="coupons-manager.coupon"/>
                    </ModalHeader>
                    <ModalBody>
                        <FormCouponManager
                            coupon={this.state.coupon}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>
                            <Translate id="coupons-manager.close"/>
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalCouponManager;